import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/services/auth.service';
import { ValidationUtil } from '../../shared/validators/passwordMatch';

@Component({
  selector: 'ps-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  public role: any;
  public resetPasswordForm: any;
  public isresettPasswordFormSubmitted!: boolean;
  public fieldPasswordType!: Boolean;
  public fieldConfirmPasswordType!: Boolean;
  public showTokenExpiredDiv: boolean = false;  //Token Expired Div
  public TokenExpired: boolean = false;  //Switch Text between Expired and Invalid
  public showSuccessDiv: boolean = false; //Show Password Successfully set
  public initializeHtmlView: boolean = false;
  public spinner: boolean = false;

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router, private route: ActivatedRoute, private toastr: ToastrService) { }
  ngOnInit() {
    this.role = localStorage.getItem("role");
    this.initialiseresetPasswordForm()
    localStorage.clear();
    this.verifyToken(this.route.snapshot.params['token']);
  }

  initialiseresetPasswordForm() {
    this.resetPasswordForm = this.fb.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    },
      {
        validator: ValidationUtil.comparePasswords // your validation method
      })

  }

  /*2.To Toggle Eye slash in Password Field*/
  toggleFieldPasswordType() {
    this.fieldPasswordType = !this.fieldPasswordType;
  }

  /*3.To Toggle Eye slash in Confirm Password Field*/
  toggleFieldConfirmPasswordType() {
    this.fieldConfirmPasswordType = !this.fieldConfirmPasswordType;
  }
  onSubmit() {
    this.isresettPasswordFormSubmitted = true
    if (this.resetPasswordForm.valid) {
      var password = this.resetPasswordForm.controls['password'].value;
      var token = this.route.snapshot.params['token'];
      var data = {
        password: password,
        resetPasswordToken: token
      }
      this.spinner = true;
      this.authService.resetPassword(data).subscribe(res => {
        if (res.status) {
          this.showSuccessDiv = true;
          this.spinner = false;
          this.toastr.success("Password Reseted Successfully");
          this.router.navigateByUrl('/auth/login');
        }
        else {
          this.toastr.error(res.message);
        }
      })
    }

  }
  /*5.To Verify Token*/
  verifyToken(token: any) {
    this.authService.verifyResetToken(token).subscribe(res => {
      this.initializeHtmlView = true;
      if (!res.validToken) {
        this.showTokenExpiredDiv = true;
        if (res.code == 108) {
          this.TokenExpired = true;
        }
      }
    })
  }
  // back
  back() {
    this.router.navigateByUrl("/auth/login");
  }
}
